module.exports = "<div v-show=show transition=mui-actionsheet-mask> <div class=mui-actionsheet-mask @click=closeActionSheet></div> <div class=mui-actionsheet v-show=show transition=mui-actionsheet> <div class=mui-actionsheet-menu> <div v-for=\"button in buttons\" :class=\"['mui-actionsheet-button'].concat(button.classes)\" @click=button.onClick> {{ button.name }} </div> </div> <div class=mui-actionsheet-action> <div class=mui-actionsheet-button @click=closeActionSheet>{{ cancelText || '取消' }}</div> </div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/action-sheet/index.vue
 ** module id = 154
 ** module chunks = 0
 **/